'use strict';

var angular = require('angular');
var StrategyAllocationAuthAvailDirective = function StrategyAllocationAuthAvailDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-allocation-auth-avail.html'),
    controller: 'StrategyAllocationAuthAvailController',
    scope: {
      strategy: '=',
      activeEntityType: '=',
      closeHandler: '&',
      isStatementEmpty: '='
    },
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
    }
  };
};
StrategyAllocationAuthAvailDirective.$inject = [];
module.exports = StrategyAllocationAuthAvailDirective;